import { hide } from 'redux-modal'
import { CONTACT_STORE_MODAL } from 'constant'

export const closeContactStoreModal = () => dispatch => {
  dispatch(hide(CONTACT_STORE_MODAL))
}
